import { useTranslation } from "react-i18next";
import MaskedLeadTimeInput from "components/input/MaskedLeadTimeInput";
import {
  leadTimeDigitsToStorage,
  leadTimeToFormDigits,
} from "views/vendors/constants/vendorLeadTime";

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
};

export default function VendorLeadTimeInput({
  value,
  onChange,
  disabled = false,
  className,
}: Props) {
  const { t } = useTranslation();
  const tr = (key: string) => t(`views.vendors.vendorItemFields.${key}`);

  return (
    <MaskedLeadTimeInput
      value={leadTimeToFormDigits(value)}
      onValueChange={(digits) => {
        const stored = leadTimeDigitsToStorage(digits) ?? "";
        onChange(stored);
      }}
      disabled={disabled}
      placeholder={tr("leadTimePlaceholder")}
      className={className}
    />
  );
}
